import React from 'react';
import { Button } from './ui/button';
import { ROSTER_COPY } from '../constants/participantRoster';

interface UserRosterButtonProps {
  isBotConnected: boolean;
  /** The signed-in user owns (added) the connected bot. */
  isBotOwner: boolean;
  onOpen: () => void;
}

/**
 * Reopens the participant roster on demand (the desktop apps' "User Roster"
 * button next to End Session). Only the bot's owner may change the roster, so
 * a watcher does not get the control (the services would refuse the edit).
 */
const UserRosterButton: React.FC<UserRosterButtonProps> = ({ isBotConnected, isBotOwner, onOpen }) => {
  if (!isBotConnected || !isBotOwner) {
    return null;
  }

  return (
    <Button variant="secondary" size="sm" onClick={onOpen} className="flex items-center space-x-1">
      <span>{ROSTER_COPY.userRoster}</span>
    </Button>
  );
};

export default UserRosterButton;
